import ExpandLessIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectMetrics, selectMetricsStructure } from "../../../../../store/selectors/metaDataSelectors";
import MetricsTree from "./MetricsTree.tsx";

interface Props {
  searchText: string;
  disabled: boolean;
}

const MetricsWrapper = ({ searchText, disabled }: Props) => {
  const metrics = useSelector(selectMetrics);

  if (metrics.length === 0) {
    return null;
  }

  return <Metrics searchText={searchText} disabled={disabled} />;
};

const Metrics = ({ searchText, disabled }: Props) => {
  const metrics = useSelector(selectMetrics);
  const metricsStructure = useSelector(selectMetricsStructure);
  const [metricsExpanded, setMetricsExpanded] = useState(true);

  const filteredMetrics = useMemo(() => {
    if (searchText === "") {
      return metrics;
    }
    return metrics.filter((d) => d.caption.toLowerCase().indexOf(searchText) > -1);
  }, [searchText, metrics]);

  const revertExpansion = useCallback(() => setMetricsExpanded(!metricsExpanded), [metricsExpanded]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Typography sx={{ flexGrow: 1, color: "text.primary" }} variant="subtitle2">
          Metrics
        </Typography>
        <IconButton onClick={revertExpansion}>{metricsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
      </Box>

      <Collapse
        orientation="vertical"
        in={metricsExpanded}
        sx={{ "& .MuiCollapse-wrapperInner": { display: "block" } }}
      >
        <MetricsTree
          metrics={filteredMetrics}
          structure={metricsStructure}
          disabled={disabled}
          expanded={searchText !== ""}
          visible={metricsExpanded}
        />
      </Collapse>
    </Box>
  );
};

export default MetricsWrapper;
